import {
    UPDATE_TAX_INPUT,
    REQUEST_TAX_CALC,
    RECEIVE_TAX_CALC,
    TAX_MORTGAGE_CALC_SHOW,
    TAX_MORTGAGE_CALC_HIDE,
    TAX_MORTGAGE_CALC_SAVE,
    TAX_NEXT_WIZARD_STEP,
    TAX_FROM_PROPERTY
} from "./TaxActionTypes";

const initialState = {
    
    // Questions:
    nonPropertyEarnings: 55000,
    nonPropertyDividendIncome: 0,
    propertyIncome: 24000,
    propertyAllowableExpenses: 5000,
    propertyFinanceCosts: 13000,
    goal: 'retain',     // retain, nextProperty, income
    projectionYears: 15,
    profitGoal: 30000,
    additionalAnnualInvestment: 0,
    
    // Calculated server-side:
    over150k: false,
    years: [],
    spv: null,
    personal: null,

    // State
    hasCalculation: false,
    isFetching: false,
    isStale: true,      // i.e. needs fetching
    view: 'calc',
    wizardStep: 1
};

export const TAX_INPUT_KEYS = ['nonPropertyEarnings', 'nonPropertyDividendIncome',
    'propertyIncome', 'propertyAllowableExpenses', 'propertyFinanceCosts',
    'goal', 'projectionYears', 'profitGoal', 'additionalAnnualInvestment'];

export default function (state = initialState, action) {
    switch (action.type) {
        case UPDATE_TAX_INPUT: {
            if (!TAX_INPUT_KEYS.includes(action.key)) {
                console.log("Denied updating of key: " + action.key);
                return state;
            };
            return {
                ...state,
                [action.key]: action.value,
                isStale: true
            };
        }
        case REQUEST_TAX_CALC:
            return Object.assign({}, state, {
                isFetching: true,
                isStale: false
            })
        case RECEIVE_TAX_CALC:
            return Object.assign({}, state, {
                ...action.taxCalculation,
                isFetching: false,
                isStale: false,
                lastUpdated: action.receivedAt,
                hasCalculation: true
            })
        case TAX_MORTGAGE_CALC_SHOW:
            return Object.assign({}, state, {
                view: 'mcalc'
            })
        case TAX_MORTGAGE_CALC_HIDE:
            return Object.assign({}, state, {
                view: 'calc'
            })
        case TAX_MORTGAGE_CALC_SAVE:
            return Object.assign({}, state, {
                propertyFinanceCosts: action.propertyFinanceCosts,
                view: 'calc'
            })
        case TAX_NEXT_WIZARD_STEP:
            return Object.assign({}, state, {
                wizardStep: state.wizardStep + 1
            })
        case TAX_FROM_PROPERTY:
            console.log('TAX_FROM_PROPERTY');
            return Object.assign({}, state, {
                propertyIncome: action.income,
                propertyAllowableExpenses: action.allowableExpenses,
                propertyFinanceCosts: action.financeCosts,
            })

        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/Features/TaxCalculator/TaxReducers.jsx